export default __webpack_public_path__ + "static/media/myNatureHome.c39d2837.jpeg";